var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {

            document.querySelectorAll('.hotspot').forEach(item => {
            item.addEventListener('click', event => {
                let index = item.dataset.hotspotId;
                document.querySelectorAll('.hotspot--active').forEach(element => {
                    element.classList.remove("hotspot--active");
                });
                document.querySelectorAll('.hotspot-data--active').forEach(element => {
                    element.classList.remove("hotspot-data--active");
                });
                item.classList.add("hotspot--active");
                document.querySelectorAll(".hotspot-data[data-hotspot-id='" + index + "']")[0].classList.add("hotspot-data--active");
            })
        })

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=hotspots', initializeBlock);
    }
});
